module.exports = __webpack_public_path__ + "img/banner-scholarship@1x.184e6ea0.jpg";